module.exports = __webpack_public_path__ + "static/media/henglaypic.b4b3598b.jpg";